<template>
  <section class="sec-segment">
    <div class="module_title">
      <span class="en">{{ en }}</span>
      <span class="num" :class="`num_${index}`" />
      <span class="tit">环节介绍</span>
      <span class="en">{{ en }}</span>
    </div>
    <div class="segment-wrapper" v-if="date && Object.keys(date) && Object.keys(date).length > 0">
      <div class="segment-tabs">
        <span
          v-for="(item, index) in date"
          :key="index"
          :class="{ active: cur === item }"
          @click="changeActive(item)"
          v-rseat="`click_carnival_date_${item}`"
          >{{ item }}</span
        >
      </div>
      <div class="segment-cons" :class="!isShowAll && 'segment-hidden-all'">
        <div class="segment-top" />
        <div class="segment-main">
          <div class="segment-cons-item" v-for="(item, index) in actList" :key="index">
            <div class="segment-left">
              <div class="segment-module-time">{{ item.text }}</div>
              <div class="segment-module-icon" />
            </div>
            <div class="segment-right">
              <div class="segment-rigth-wrapper" v-for="(child, cIndex) in item.list" :key="cIndex">
                <span v-if="child.text" class="segment-module-tit">&nbsp;{{ child.text }}&nbsp;</span>
                <ul class="segment-module-txt">
                  <li v-for="(desc, dIndex) in child.desc" :key="dIndex">{{ desc }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="segment-bottom" />
      </div>
      <div @click="changeShowState" class="btn-show-wrapper" v-if="!isShowAll">
        <span v-rseat="'click_carnival_segment_more'">
          点击查看更多
          <i />
        </span>
      </div>
      <div @click="changeShowState" class="btn-hidden-wrapper" v-if="isShowAll">
        <span>
          点击收起
          <i />
        </span>
      </div>
    </div>
    <empty-info v-else title="环节介绍" />
  </section>
</template>
<script>
import EmptyInfo from '../module/empty.vue'

export default {
  components: {
    EmptyInfo,
  },
  data() {
    return {
      cur: '',
      date: [],
      actList: [],
      isShowAll: false,
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    en: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    data: {
      handler: function dataHandler(next) {
        this.data = next || {}
        this.getDate(next)
      },
      deep: true,
    },
  },
  methods: {
    getDate(data = {}) {
      const date = Object.keys(data) ? Object.keys(data).sort() : []
      this.date = date
      if (date && date.length > 0) {
        const [first] = date
        this.cur = first
        this.actList = data[first]
      }
    },
    changeActive(item) {
      this.cur = item
      this.actList = this.data[item]
    },
    changeShowState() {
      this.isShowAll = !this.isShowAll
    },
  },
  mounted() {
    this.getDate(this.data)
  },
}
</script>
<style lang="less">
.sec-segment {
  max-width: 1090px;
  margin: 50px auto 68px;
  .segment-wrapper {
    position: relative;
    z-index: 2;
    margin-top: 50px;
    .btn-show-wrapper,
    .btn-hidden-wrapper {
      position: absolute;
      bottom: 0;
      right: 0;
      left: 254px;
    }
  }
  .segment-tabs {
    margin-bottom: 34px;
    font-size: 0;
    text-align: center;
    span {
      position: relative;
      background: #2f15a2;
      border: 1px solid #000000;
      padding: 11px 18px;
      font-size: 24px;
      color: #ffffff;
      cursor: pointer;
      &.active {
        background: #ceff1a;
        color: #000000;
        &::before,
        &::after {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          display: inline-block;
          content: '';
        }

        &::before {
          bottom: -16px;
          border-width: 16px 16px 0;
          border-style: solid;
          border-color: #000000 transparent transparent;
          z-index: 1;
        }
        &::after {
          bottom: -14px;
          border-width: 16px 16px 0;
          border-style: solid;
          border-color: #ceff1a transparent transparent;
          z-index: 3;
        }
      }
    }
  }

  .segment-cons {
    position: relative;
    margin-top: 20px;
    padding-right: 30px;
    box-sizing: border-box;

    &::before,
    &::after {
      display: inline-block;
      content: '';
      background-repeat: no-repeat;
      background-size: 100%;
      position: absolute;
      z-index: 1;
      width: 230px;
      height: 230px;
    }
    &::before {
      background-image: url('~@/assets/carnival2020/start_up.png');
      left: 0;
      top: 10px;
    }
    &::after {
      background-image: url('~@/assets/carnival2020/start_down.png');
      bottom: 0;
      left: 8px;
      height: 220px;
    }
    .segment-top {
      position: relative;
      top: 10px;
      width: 239px;
      height: 68px;
      background: #000000;
      background: linear-gradient(-155deg, transparent 60px, #000000 0);
    }
    .segment-bottom {
      height: 94px;
      background: linear-gradient(37deg, transparent 40px, #2f15a2 0) left;

      &::before {
        background: linear-gradient(37deg, transparent 54px, #000000 0) left;
      }
    }
    .segment-main {
      padding-top: 10px;
    }
    &.segment-hidden-all {
      max-height: 600px;
      overflow: hidden;
      .segment-main {
        max-height: 440px;
        overflow: hidden;
      }
    }
  }

  .segment-bottom,
  .segment-left {
    position: relative;
    width: 254px;
    background: #2f15a2;
    &::before {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 13px;
      display: block;
      content: '';
      background: #000000;
      border-right: 1px solid #ceff1a;
    }
  }

  .segment-cons-item {
    display: flex;
    font-size: 22px;
    .segment-left {
      flex-shrink: 0;
      margin-right: 30px;

      &::before {
        display: block;
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 13px;
        background: #000000;
        border-right: 1px solid #ceff1a;
      }

      .segment-module-time {
        position: relative;
        z-index: 2;
        box-sizing: border-box;
        width: 156px;
        height: 39px;
        line-height: 39px;
        margin-left: 40px;
        padding: 0 10px;
        text-align: center;
        background: #ceff1a;
        background: linear-gradient(-135deg, transparent 10px, #ceff1a 0);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .segment-module-icon {
        position: absolute;
        z-index: 2;
        top: 0;
        right: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        background: #ceff1a;
        transform: rotate(45deg);
        &::after {
          display: inline-block;
          content: '';
          width: 10px;
          height: 10px;
          background: #ceff1a;
          border: 1px solid #000000;
        }
      }
    }
    .segment-right {
      margin-bottom: 20px;
      .segment-rigth-wrapper {
        margin-bottom: 50px;
        text-align: left;
      }
      .segment-module-tit {
        line-height: 34px;
        font-size: 32px;
        color: #ceff1a;
        box-shadow: inset 0 -28px 0 -12px #030207;
        &::after {
          display: block;
          content: '';
          width: 0;
          height: 0;
          margin-bottom: 20px;
        }
      }
      .segment-module-txt {
        margin-bottom: 30px;
        font-size: 0;
        li {
          position: relative;
          margin-bottom: 24px;
          padding-left: 30px;
          line-height: 30px;
          font-size: 22px;
          color: #ffffff;
          list-style: none;
          text-align: left;
          &::before {
            position: absolute;
            top: 8px;
            left: 0;
            display: inline-block;
            content: '';
            border-width: 0 10px 16px;
            border-style: solid;
            border-color: transparent transparent #ceff1a;
          }
        }
      }
    }
    &:first-child {
      .segment-left {
        background: linear-gradient(-135deg, transparent 10px, #2f15a2 0);
      }
    }
  }
}
</style>
